import { awaitDataServiceFetcher } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/DataServiceFetchers';
import { normalizeEmptyResponseToSuccessResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/infrastructure';
import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { IDeviceRepository } from '../entities/IDeviceRepository';
import { DeviceData, RegisterDeviceRequestDTO, RegisterDeviceResponseDTO } from '../entities';
import { DeleteDeviceResponseBody } from '../entities/DeleteDeviceResponseDTO';
import { CreateDeleteDeviceAuthorizationResponseBody } from '../entities/CreateDeleteDeviceAuthorizationResponseDTO';
import { devicesDTOToDevicesAdapter } from './devicesDTOToDevicesAdapter';

class DeviceRepositoryImpl implements IDeviceRepository {
  constructor() {
    this.GetDevices = this.GetDevices.bind(this);
    this.CreateDeleteDeviceAuthorization = this.CreateDeleteDeviceAuthorization.bind(this);
    this.DeleteDevice = this.DeleteDevice.bind(this);
    this.RegisterNewDevice = this.RegisterNewDevice.bind(this);
  }

  GetDevices(pageSize: number, pageOffset: number): Promise<DeviceData> {
    return awaitDataServiceFetcher({
      payload: Object.assign({
        method: 'GET',
        url: `/secure-web/api/private/devices/`,
        dataAdapter: devicesDTOToDevicesAdapter,
        params: {
          perPage: pageSize,
          page: pageOffset,
        },
      }),
    });
  }

  CreateDeleteDeviceAuthorization(deviceId: number): Promise<CreateDeleteDeviceAuthorizationResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: '/secure-web/api/private/devices/deletion/authorization',
        data: { id: deviceId },
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
      },
    });
  }

  DeleteDevice(requestId: string, successCallback: SuccessCallback): Promise<DeleteDeviceResponseBody> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'PUT',
        url: `/secure-web/api/private/devices/deletion`,
        data: { requestId },
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
        nextCallback: successCallback,
      },
    });
  }

  RegisterNewDevice(
    requestData: RegisterDeviceRequestDTO,
    successCallback?: SuccessCallback,
    errorCallback?: ErrorCallback,
  ): Promise<RegisterDeviceResponseDTO> {
    return awaitDataServiceFetcher({
      payload: {
        method: 'POST',
        url: `/secure-web/api/private/devices`,
        data: requestData,
        dataAdapter: normalizeEmptyResponseToSuccessResponse,
        nextCallback: successCallback,
        onErrorCallback: errorCallback,
      },
    });
  }
}

export { DeviceRepositoryImpl };
